import image01 from "images/jobExpo/01.jpeg";
import image02 from "images/jobExpo/02.jpg";
import image03 from "images/jobExpo/03.jpeg";
import image04 from "images/jobExpo/04.png";
import image05 from "images/jobExpo/05.png";
import image06 from "images/jobExpo/06.png";
import image07 from "images/jobExpo/07.png";
import image08 from "images/jobExpo/08.png";
import image09 from "images/jobExpo/09.jpg";
import image10 from "images/jobExpo/10.png";
import image11 from "images/jobExpo/11.png";
import image12 from "images/jobExpo/12.png";
import image13 from "images/jobExpo/13.png";
import image14 from "images/jobExpo/14.PNG";
import image15 from "images/jobExpo/15.png";
import companyImagePlaceholder from "images/jobExpo/placeholder.png";

export const companiesData = [
  { id: 1, image: image01 },
  { id: 2, image: image02 },
  { id: 3, image: image03 },
  { id: 4, image: image04 },
  { id: 5, image: image05 },
  { id: 6, image: image06 },
  { id: 7, image: image07 },
  { id: 8, image: image08 },
  { id: 9, image: image09 },
  { id: 10, image: image10 },
  { id: 11, image: image11 },
  { id: 12, image: image12 },
  { id: 13, image: image13 },
  { id: 14, image: image14 },
  { id: 15, image: image15 },
];

export const getCompanyImageById = (id) => {
  return (
    companiesData.find((c) => c.id === id)?.image || companyImagePlaceholder
  );
};
